import { Endpoints } from '../../../common/model/config';

export const qaEndpoints: Endpoints = {
  api: 'https://api.qa.onyo.app/',
  graphql: 'https://graphql.qa.onyo.app/graphql',
  payments: 'https://payments.qa.onyo.app/',
  authDomain: 'user-auth.onyo.app',
  enterpriseUserForm: 'https://enterprise-user.staging.onyo.app/',
};
